import { Notificacion, NotificacionExtendida } from '@components/general/Alertas/Alertas';
import UserContext from '@context/User/UserContext';
import { deactivateDescuentoConvenio } from '@helpers/httpRequests/httpRequestConvenios/httpRequestConvenios';
import { createKueskiPaymentIntent, createPaymentIntent, updatePaymentIntentPlan } from '@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import { Button, Form, Image, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const FormularioNuevaCompra = ({
	imgProducto = require("@assets/images/click.png"), 
	precioProducto , 
	precioProductoUSD, 
	nombreProducto, 
	compraExterna, 
	compraLectura,
	compraKueski = false, 
	compraConvenio = false,
	codigoConvenio = '', 
	folioContrato, 
	codigoAplicado = undefined, 
	precios = undefined, 
	preciosXCodigo = undefined, 
	valueRadioButton = undefined, 
	idCodigoDescuento = undefined, 
	successUrl = undefined, 
	msiMax = 3, 
	msiEnabled = false,
	esLiquidacion = false,
	esRenovacion = false,
	idRegion = 0,
	isMobile = false,
 }) => {

	/**
	 * DEFINICION DE PARAMETROS PARA EL COMPONENTE
	 * imgProducto: Imagen del logo del producto a usar en el componente.
	 * precioProducto: Precio a establecer en MXN
	 * precioProductoUSD: Precio para la venta en Dolares
	 * nombreProducto: Nombre de producto
	 * compraExterna: Bandera para indicar en el componente si la compra es fuera de México.
	 * compraKueski: Bandera para indicar si el componente acepta compras con Kueski.
	 * compraConvenio: Bandera para indicar si el componente es para compras con convenio como la UVEG.
	 * codigoConvenio: Código del convenio para desactivarlo al realizar la compra (Solo en compras con convenio).
	 * folioContrato: Folio que se usará si se efectúa la compra.
	 * codigoAplicado: Código de descuento si es que aplica.
	 * precios: Listado de precios que se usa para la compra por stripe.
	 * preciosXcodigo: Listado de precios por codigo que se usa para el pago con stripe.
	 * valueRadioButton: Valor del radio button que se obtiene en caso de querer renovar, pagar de contado o a meses.
	 * idCodigoDescuento: id del codigo de descuento para la compra por stripe.
	 * successUrl: URL de exito para cuando se concrete la compra (APLICA SOLO EN COMPRAS CON STRIPE).
	 * msiMax: Máximo de meses sin intereses a mostrar una vez se coloqué la tarjeta del cliente.
	 * msiEnabled: Bandera para indicar al componente si aceptará compras a meses sin intereses.
	 * esLiquidacion: Bandera para comprobar si el modulo es para uso de pagos de liquidacion
	 * idRegion: Region del usuario (Se usa en liquidaciones).
	 * isMobile: Se usa como parametro del contextValue en compras de liquidacion.
	 * esRenovacion : Se usa para renovar las licencias Click+
	 */

    const { contextValue, setContextValue } = useContext(UserContext);

    const history = useHistory();

    const [loading, setLoading] = useState(false);

    const stripe = useStripe();
	const elements = useElements();
	const [cargando, setCargando] = useState(false);
	const [message, setMessage] = useState('');

	const [nombreCliente, setNombreCliente] = useState('');
	const [correoCliente, setCorreoCliente] = useState('');
	const [diferirCompraLectura, setDiferirCompraLectura] = useState(false);
	const [paymentIntentPlan, setPaymentIntentPlan] = useState(null);
	const [mesesDiferir, setMesesDiferir] = useState(0);

	const [showCheck, setShowCheck] = useState(false);
	const [cardComplete, setCardComplete] = useState(false);
	const [cardError, setCardError] = useState(null);

	const [isKueskiPurchase, setIsKueskiPurchase] = useState(false);
	
	const handleCardChange = (event) =>{
		if((event.complete || event.value?.length > 0) && msiEnabled) {
			// console.log("SE MUESTRA EL CHECK")
			setShowCheck(true);
		}else{ 
			// console.log("SE OCULTA EL CHECK")
			setShowCheck(false);
		}
	}

	const handleOnChange = ({currentTarget}) => {
		const {value, name} = currentTarget;

		if(name === 'nombreCliente'){
			setNombreCliente(value);
		}

		if(name === 'correoCliente'){
			setCorreoCliente(value);
		}
	}

	
	
	
	const createPaymentMethod = async() => {
		const cardElement = elements.getElement(CardElement);

		
		if (!cardElement) {
			console.error("CardElement no está montado");
			return;
		}
		try {
			const { paymentMethod, error } = await stripe.createPaymentMethod({
				type: 'card',
				card: elements.getElement(CardElement),
				billing_details: {
					name: nombreCliente,
				},
			});

			console.log(paymentMethod)
			if (error) {
				console.error("Stripe error:", error.message);
				return;
			}

			console.log("Método de pago creado:", paymentMethod);
			return paymentMethod;



		} catch (error) {
			console.log(error)
		}
	}

	const createPaymentIntentPlans = async() => {
		try {
			setCargando(true);
			const paymentMethod = await createPaymentMethod();
			// console.log(paymentMethod)
			const res = await createPaymentIntent({
				amount: compraExterna ? precioProductoUSD: precioProducto,
				currency: compraExterna ? "usd": "mxn",
				paymentMethodId: paymentMethod.id,
			  })

			//   console.log(res);
			  setPaymentIntentPlan(res);

			  setCargando(false);

		} catch (error) {
			console.log(error)
			setCargando(false);
		}
	}

	const updatePaymentIntent = async({currentTarget}) => {
		try {
			setCargando(true);
			const {value} = currentTarget;

			setMesesDiferir(value==='contado' ? 0 : value);

			// console.log(value);

			const paymentMethod = await createPaymentMethod();
			const res = await updatePaymentIntentPlan({
				amount: compraExterna ? precioProductoUSD: precioProducto,
				currency: compraExterna ? "usd": "mxn",
				paymentMethodId: paymentMethod.id,
				count: value,
			  })

			//   console.log(res);
			  setPaymentIntentPlan(res);
			  setCargando(false);

		} catch (error) {
			  setCargando(false);
			  console.log(error)
		}
	}


	const handleKueskiPayment = async(e) => {
		e.preventDefault();
		setLoading(true);

		if(nombreCliente === '' || correoCliente === ''){
			console.log("Campos vacios");
			setMessage('Agrega tu nombre y un correo electrónico');
			setLoading(false);
			return;
		  }
	  
		try {
			//EMPAQUETAR LA INFORMACION PARA ENVIARLA Y AGRAGARLA A LA URL SUCCESS


			const host = window.location.origin;

			console.log(host);

			if(host.includes("qacursos") || host.includes("localhost")){
				console.log("Se usa precio de pruebas");
				precioProducto = 25000;
			}

			const infoCompra= {
				description: nombreProducto,
				amount: {
					total: precioProducto / 100,
					currency: 'MXN',
					details: {
						subtotal: precioProducto / 100,
					}
				},
				items: 
					[
						{
							"name": nombreProducto,
							"description": nombreProducto,
							"quantity": 1,
							"price": precioProducto / 100,
							"currency": "MXN"
						}
						
					],
				folioContrato,
				compraLectura,
				liquidacion: esLiquidacion,
				renovacion: esRenovacion,
				nombreCliente,
				correoCliente
			}

			// const infoCompra= {
			// 	description: nombreProducto,
			// 	amount: {
			// 		total: 250,
			// 		currency: 'MXN',
			// 		details: {
			// 			subtotal: 250,
			// 		}
			// 	},
			// 	items: 
			// 		[
			// 			{
			// 				"name": nombreProducto,
			// 				"description": nombreProducto,
			// 				"quantity": 1,
			// 				"price": 250,
			// 				"currency": "MXN"
			// 			}
						
			// 		],
			// 	folioContrato,
			// 	compraLectura,
			// 	liquidacion: false,
			// 	nombreCliente,
			// 	correoCliente
			// }


			// console.log(infoCompra)

			const {data, status} = await createKueskiPaymentIntent(infoCompra);

			// console.log(data);


			delete contextValue.preciosDescuento;

			//TODO: Agregar los pagos de liquidacion y de renovacion, hacer pruebas con QA y subir a prod.

			if(esLiquidacion) {
				setContextValue({
				...contextValue,
				compraKueski: true,
				precioCompraKueski: precioProducto,
				stripeSession: {
					payment_intent: data.payment_id,
				},
				folioContrato: folioContrato,
				isMobile,
				idRegion
			});
			}else if(esRenovacion){
				setContextValue({
				...contextValue,
				renovacion: {
					...contextValue.renovacion,
					renovacionKueski: true,
					pagoIniciado: true,
					// stripeSession: checkoutSession,
					metodoPago: valueRadioButton,
					precios
				},
			});
			}else{
				setContextValue({
					...contextValue,
					compra: {
						...contextValue.compra,
						kueskiSession: {
							metadata: {
								metodoPago: 'contado',
								folioContrato
							},
							payment_intent: data.payment_id,
							order_id: data.order_id,
	
						},
						kueskiAmount: precioProducto,
						codigoAplicado: compraLectura ? true : codigoAplicado,
						compraKueski: true,
						idCodigoDescuento: compraLectura ? precios.lecturaVeloz.idCodigo : idCodigoDescuento,
						preciosSeleccionados: preciosXCodigo,
						metodoPago: compraLectura ? "contado" :valueRadioButton,
					},
				});	

			}
			

			//CREAR EL PAGO DE KUESKI POR BACK Y REDIRIGIR AL USUARIO AL PAYMENT INTENT
			
			NotificacionExtendida("success", "Proceso de pago creado, por favor no cierres esta ventana")

			if(status === "success"){
				setTimeout(() => {
					window.open(data.callback_url, '_self')
				}, 3000);
			}
			
		} catch (error) {
			console.log(error);
			setNombreCliente("");
			setCorreoCliente("");
			setDiferirCompraLectura(false);
			setPaymentIntentPlan(null);
			setMesesDiferir(0);
		
			setLoading(false);
			Notificacion("error", "Ocurrió un error con el proceso de pago, por favor intente de nuevo")
		}
	}
  
	const handleSubmit = async(e) => {
	  e.preventDefault();
	  setLoading(true);

	  if (!stripe || !elements) {
		console.log("Stripe aún no está cargado");

		return;
	  }
	  const cardElement = elements.getElement(CardElement);

	  console.log(idCodigoDescuento)

	  console.log(cardElement)

	  if(nombreCliente === '' || correoCliente === ''){
		console.log("Campos vacios");
		setMessage('Agrega tu nombre y un correo electrónico');
		setLoading(false);
		return;
	  }
  
	 try {
  
	
		// if (error) {
		//   console.log(error);
		//   Notificacion("error", "Ocurrió un error con el pago, intente con otro método de pago")
		//   return;
		// }
		
		//Se crea el paymentIntent sin plan de meses sin intereses, aqui validar si está vacio el state de payment intent plan

		const paymentMethod = await createPaymentMethod();

		console.log(paymentMethod);

		let res = {};

		if(!paymentIntentPlan){
			console.log('Creando paymentIntent')
			 res = await createPaymentIntent({
			  amount: compraExterna ? precioProductoUSD: precioProducto,
			  currency: compraExterna ? "usd": "mxn",
			  paymentMethodId: paymentMethod.id,
			})
	  
			// console.log(res)

		}

		console.log(res);

		const result = await stripe.confirmCardPayment(!paymentIntentPlan ? res.client_secret : paymentIntentPlan.client_secret, {
			payment_method: {
			  card: elements.getElement(CardElement),
			  billing_details: {
				name: nombreCliente,
				email: correoCliente,
			  },
			},
		  });
		  
		  if (result.error) {
			// console.log("❌ Error al confirmar pago:", result.error.message);
			NotificacionExtendida("error", result.error.message)

		  } else if (result.paymentIntent.status === "succeeded") {
			// console.log("✅ Pago exitoso");

			//En caso de ser una compra de convenio se desactiva el codigo de descuento en la base de datos.
			if(compraConvenio) {
				await deactivateDescuentoConvenio(codigoConvenio, folioContrato);
			}

			NotificacionExtendida("success", successUrl ? "Compra realizada con éxito" : "Compra realizada con éxito, por favor no cierres esta ventana")


			delete contextValue.preciosDescuento;

			if(esLiquidacion){
				setContextValue({
					...contextValue,
					folioContrato,
					idRegion,
					stripeSession: {
							metadata: {
								metodoPago: 'contado',
								folioContrato
							},
							payment_intent: result.paymentIntent.id,
							payment_method: result.paymentIntent.payment_method,
	
						},
				});	

			}else if (esRenovacion){

				
				setContextValue({
					...contextValue,
					renovacion: {
						...contextValue.renovacion,
						renovacionKueski: false,
						pagoIniciado: true,
						stripeSession: {
							metadata: {
								metodoPago: 'contado',
								folioContrato
							},
							payment_intent: result.paymentIntent.id,
							payment_method: result.paymentIntent.payment_method,
	
						},
						metodoPago: valueRadioButton,
						precios
					},
				});	
			}else{
				console.log("Informacion de la compra");
				console.log({preciosXCodigo});
				console.log({idCodigoDescuento});
				console.log({codigoAplicado});
				setContextValue({
				...contextValue,
				folioContrato,
				compra: {
					...contextValue.compra,
					stripeSession: {
						metadata: {
							metodoPago: 'contado',
							folioContrato
						},
						payment_intent: result.paymentIntent.id,
						payment_method: result.paymentIntent.payment_method,

					},
					codigoAplicado: compraLectura ? true : codigoAplicado,
					idCodigoDescuento: idCodigoDescuento,
					preciosSeleccionados: preciosXCodigo,
					metodoPago: compraLectura ? "contado" :valueRadioButton,
				},
			});	
			}


			if(successUrl){
                setTimeout(() => {
                    history.replace(successUrl)
                }, 3000);
            }

		  } else if (result.paymentIntent.status === "requires_action") {
			// console.log("⚠️ Se necesita autenticación 3D Secure");
			// Stripe se encarga de mostrar el popup automáticamente.
		  }

		//   console.log(result)

		setNombreCliente("");
		setCorreoCliente("");
		cardElement.clear();
		setDiferirCompraLectura(false);
		setPaymentIntentPlan(null);
		setMesesDiferir(0);
	
		setLoading(false);
	 } catch (error) {
		console.log(error)
		setNombreCliente("");
		setCorreoCliente("");
		cardElement.clear();
		setDiferirCompraLectura(false);
		setPaymentIntentPlan(null);
		setMesesDiferir(0);
	
		setLoading(false);
		Notificacion("error", "Ocurrió un error con el pago, por favor intente de nuevo")

	 }
	};



    useEffect(() => {
        if(diferirCompraLectura){
        //Crear paymentIntent para recuperar los planes disponibles
        createPaymentIntentPlans();
        }

        if(!diferirCompraLectura && paymentIntentPlan !== null){
        setPaymentIntentPlan(null);
        setMesesDiferir(0)
        }

    }, [diferirCompraLectura])

    

    useEffect(() => {
        if(elements) {
            const cardElement = elements.getElement(CardElement);
            if (!cardElement) return;
    
            const handleChange = (event) => {
                setCardComplete(event.complete); // true si todos los campos están llenos
                setCardError(event.error ? event.error.message : null); // guarda el error si hay
            };
    
            cardElement.on('change', handleChange);
    
            return () => {
                cardElement.off('change', handleChange);
            };
        }
    }, [elements, isKueskiPurchase]);
  return (
    <Form className="form-lectura-stripe w-100" onSubmit={isKueskiPurchase ? handleKueskiPayment : handleSubmit}>
        <div className="text-center">
        <Image style={{margin: "auto"}} src={imgProducto} width={200} className="fluid" alt="Lectura logo" />
        <h3 className="text-dark mt-4">{nombreProducto}</h3>
		<h2 className='font-bold'>${!compraExterna ? precioProducto / 100 : precioProductoUSD / 100}.00 {!compraExterna ? "MXN" : "USD" }</h2>
        </div>
        <Form.Control onChange={handleOnChange} value={nombreCliente} name="nombreCliente" className="mb-4 mt-3" type="input" placeholder="Nombre completo" />
        <Form.Control onChange={handleOnChange} value={correoCliente} name="correoCliente" className="mb-4 mt-3" type="email" placeholder="Correo electrónico" />
        
		{!isKueskiPurchase ? (
			<CardElement onChange={handleCardChange} options={{
				style: {
				base: {
					fontSize: '16px',
					color: '#32325d',
					fontFamily: 'Arial, sans-serif',
					'::placeholder': {
					color: '#a0aec0',
					},
				},
				invalid: {
					color: '#e53e3e',
				},
				},
			}} />
		): null}

        {showCheck && (
            <Form.Check 
                checked={diferirCompraLectura}
                className="mt-4 mb-3"
                style={{color: "#32325d", cursor: "pointer"}}
                type={'checkbox'}
                id={`msi`}
                label={`Diferir pago a meses sin intereses`}
                onChange={() => setDiferirCompraLectura(!diferirCompraLectura)}
            />
        )}

        {(paymentIntentPlan !== null && diferirCompraLectura) && (
            (paymentIntentPlan.payment_method_options.card.installments.available_plans.length > 0) ? 
            (
				esLiquidacion ? (
					<Form.Select onChange={updatePaymentIntent} aria-label="Default select example">
						<option value="contado">Selecciona un plan</option>
						{paymentIntentPlan.payment_method_options.card.installments.available_plans.map((plan) => (
							(plan.count > 3 && plan.count <= msiMax) && (
								<option value={plan.count}>{`${plan.count} meses sin intereses`}</option>
							)
						))}

					</Form.Select>
				) : (
					<Form.Select onChange={updatePaymentIntent} aria-label="Default select example">
						<option value="contado">Selecciona un plan</option>
						{paymentIntentPlan.payment_method_options.card.installments.available_plans.map((plan) => (
							(plan.count <= msiMax) && (
								<option value={plan.count}>{`${plan.count} meses sin intereses`}</option>
							)
						))}

					</Form.Select>
				)
            ): (
                <span className="text-danger my-3">Tu metodo de pago no permite diferir tu compra a meses sin intereses</span>
            )
            
        )}

			{(!showCheck && compraKueski ) && (
				<div className="mt-4">
					<div className='text-center'>
						<span className="text-dark">Paga en hasta en 12 quincenas sin tarjeta de crédito con <br/>{<Image src={require("@assets/images/Kueski/logoKueski.png")} width={100} />}</span>
					</div>
					<Form.Check 
						checked={isKueskiPurchase}
						className="mt-4 mb-3"
						style={{color: "#32325d", cursor: "pointer"}}
						type={'checkbox'}
						id={`kueski-pay`}
						label={`Pagar con Kueski Pay`}
						onChange={() => setIsKueskiPurchase(!isKueskiPurchase)}
					/>	
				</div>
			)}

            <div className="text-dark mt-4">
                <p><b>Resumen de tu compra:</b></p>
                <p>{esLiquidacion ? "Total a liquidar" : "Costo total"}: <b>${compraExterna ? precioProductoUSD / 100 : precioProducto /100}.00 {compraExterna ? 'USD' : 'MXN'}</b></p>
                {(diferirCompraLectura && paymentIntentPlan !== null && paymentIntentPlan.payment_method_options.card.installments.available_plans.length > 0 && mesesDiferir > 0) && (
                    <p>Costo en cuotas: {mesesDiferir} pagos de <b>${( compraExterna ? (precioProductoUSD / 100) : (precioProducto / 100) / mesesDiferir).toFixed(2)}MXN</b> </p>
                )}

				{isKueskiPurchase && (
					<small><b>Para realizar tu pago serás redirigido al portal de {<Image src={require("@assets/images/Kueski/logoKueski.png")} width={100} />}.</b></small>
				)}
            </div>


        
            {(cargando || loading) ? (
                <div className="text-center">
                    <Spinner variant="secondary" />
                </div>
            ): (
                <div className="mt-4 d-grid gap-2">
                    <Button className="btn btn-success" type="submit" disabled={!stripe || loading || (isKueskiPurchase ? false : !cardComplete) }>
                        {loading ? <b>Procesando...</b> : <b>Pagar</b>}
                    </Button>
                </div>
            )}

		  {isKueskiPurchase && (
			  <div className="text-center mt-4">

				  <small style={{color: 'black', fontWeight: "bold"}}>Tienes una hora para completar tu compra, de lo contrario tendrás que comenzar de nuevo con el proceso de compra</small>
			  </div>
		  )}


			{isKueskiPurchase && (
				<div className="text-center mt-4">
					
					<small style={{color: 'gray'}}>Sujeto a aprobación de crédito. Consulta CAT, Comisión, restricciones y requisitos de contratación en <a href='https://kueskipay.com' target="_blank" rel="noreferrer" >kueskipay.com</a></small>
				</div>
			)}
        {cardError && <p className="text-danger mt-2">{cardError}</p>}
        {message !== '' && <p className="text-danger mt-2">{message}</p>}
    </Form>
  )
}

export default FormularioNuevaCompra